import { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import "./orderdetails.css";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
interface DocumentType {
  name: string;
  status: string;
  statusClass: string;
  action?: string;
}

interface StepType {
  applicationNumber: string;
  serviceName: string;
  statusClass: string;
  serviceStatus: string;
  RecordId?: string | number;
}

interface ApplicantType {
  applicationNumber?: string;
  applicant_Name?: string;
  serviceName?: string;
  paymentStatus?: string;
  serviceStatus?: string;
  statusClass?: string;
  disabled?: boolean;
  select?: boolean;
  details: StepType[];
  documents?: DocumentType[];
  PackageId?: number | null;
  packageName?: string;
}



const OrderDetails = () => {
  const location = useLocation();
  
    const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<string>("application");
  const [orders, setOrders] = useState<any>(null);

  const handleAccordionToggle = (key: string) => {
    setActiveKey((prev) => (prev === key ? null : key));
  };
  const getIconClass = (statusClass: string) => {
    switch (statusClass) {
      case "verified":
        return "fa-check";
      case "invalid":
        return "fa-xmark";
      case "review":
        return "fa-hourglass-half";
      default:
        return "fa-circle-question";
    }
  };

  const formatDate = (dateString: string | Date) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ''; // Invalid date check
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  };
  

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const orderNumber = queryParams.get("orderNumber"); // Get orderNumber from URL params

    if (orderNumber) {
      const fetchOrderDetails = async () => {
        try {
          const response = await axiosInstance.get(`/api/user/getOrderDetails?orderNumber=${orderNumber}`);
         
          setOrders(response.data);
        } catch (error) {
          navigate('/accounts/orders');
          console.error("Error fetching order details:", error);
        }
      };

      fetchOrderDetails();
    }
  }, [location]);


  return (
    <>
      <div className="row layout-border rounded-3">
        <div className="d-flex justify-content-between align-items-center mb-3 px-3 py-3 border-bottom">
          <div className="d-flex gap-4 justify-content-between align-items-center w-100">
            <div className="d-flex align-items-center p-2 px-4 layout-border rounded-3 bg-white cursor-pointer" onClick={() => navigate('/accounts/orders')}>
              <svg
                width="7"
                height="13"
                viewBox="0 0 7 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 1.625L1 6.625L6 11.625"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
                         <div>
               <small className="text-muted font-12">Ordered on</small>
               <p className="text-black font-14 ff-semibold mb-0">
               {formatDate(orders?.orders?.[0]?.createdon)}
               </p>
             </div>
             <div>
               <small className="text-muted font-12">Order ID</small>
               <p className="mb-0 text-black font-14 ff-semibold mb-0">
                 {orders?.orders?.[0]?.orderNumber }
               </p>
             </div>
             <div>
               <small className="text-muted font-12">Status</small>
               <p className="mb-0 status-inreview font-14 ff-semibold  mb-0">
                 {orders?.orders?.[0]?.orderStatus}
               </p>
             </div>
             <div>
               <small className="text-muted font-12">Payment Status</small>
               <p className="mb-0 status-inreview font-14 ff-semibold  mb-0">
                 {orders?.orders?.[0]?.paymentstatus }
               </p>
             </div>
            <div>
              <button className="btn bg-2 border-0 py-2 px-4 d-flex align-items-center gap-1 text-black ff-semibold font-12">
                <svg
                  width="12"
                  height="15"
                  viewBox="0 0 12 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.42578 1V3.85152C7.42578 4.04058 7.50089 4.22191 7.63458 4.3556C7.76827 4.48929 7.94959 4.5644 8.13866 4.5644H10.9902"
                    stroke="black"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.9902 7.41591V12.4061C11.0239 12.6751 10.9705 12.9479 10.8379 13.1844C10.7053 13.4209 10.5005 13.6087 10.2533 13.7203C10.0062 13.8319 9.72988 13.8614 9.46478 13.8045C9.19968 13.7476 8.95978 13.6073 8.78023 13.4041C8.67021 13.2633 8.52958 13.1495 8.36901 13.0712C8.20843 12.9929 8.03213 12.9522 7.85349 12.9522C7.67484 12.9522 7.49854 12.9929 7.33796 13.0712C7.17739 13.1495 7.03676 13.2633 6.92674 13.4041C6.81673 13.5448 6.6761 13.6587 6.51552 13.737C6.35495 13.8153 6.17865 13.856 6 13.856C5.82135 13.856 5.64505 13.8153 5.48448 13.737C5.3239 13.6587 5.18327 13.5448 5.07326 13.4041C4.96324 13.2633 4.82261 13.1495 4.66204 13.0712C4.50146 12.9929 4.32516 12.9522 4.14651 12.9522C3.96787 12.9522 3.79157 12.9929 3.63099 13.0712C3.47042 13.1495 3.32979 13.2633 3.21977 13.4041C3.04022 13.6073 2.80032 13.7476 2.53522 13.8045C2.27012 13.8614 1.99376 13.8319 1.74665 13.7203C1.49955 13.6087 1.29468 13.4209 1.16209 13.1844C1.02949 12.9479 0.976137 12.6751 1.00985 12.4061V2.42576C1.00985 2.04762 1.16006 1.68498 1.42744 1.41759C1.69482 1.15021 2.05747 1 2.4356 1H7.42576L10.9902 4.5644V7.59413"
                    stroke="black"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <div>Invoice</div>
              </button>
            </div>
          </div>
        </div>
        <div className="px-3 mb-3 d-flex gap-3 order-action-buttons">
          <button
            className={`action-btn ${
              activeTab === "application" ? "active" : ""
            }`}
            onClick={() => setActiveTab("application")}
          >
            <span className="icon">
              <svg
                width="16"
                height="21"
                viewBox="0 0 16 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 3.25H3C2.46957 3.25 1.96086 3.46071 1.58579 3.83579C1.21071 4.21086 1 4.71957 1 5.25V17.25C1 17.7804 1.21071 18.2891 1.58579 18.6642C1.96086 19.0393 2.46957 19.25 3 19.25H13C13.5304 19.25 14.0391 19.0393 14.4142 18.6642C14.7893 18.2891 15 17.7804 15 17.25V5.25C15 4.71957 14.7893 4.21086 14.4142 3.83579C14.0391 3.46071 13.5304 3.25 13 3.25H11"
                  stroke="#000"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 3.25C5 2.71957 5.21071 2.21086 5.58579 1.83579C5.96086 1.46071 6.46957 1.25 7 1.25H9C9.53043 1.25 10.0391 1.46071 10.4142 1.83579C10.7893 2.21086 11 2.71957 11 3.25C11 3.78043 10.7893 4.28914 10.4142 4.66421C10.0391 5.03929 9.53043 5.25 9 5.25H7C6.46957 5.25 5.96086 5.03929 5.58579 4.66421C5.21071 4.28914 5 3.78043 5 3.25Z"
                  stroke="#000"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 10.25H11"
                  stroke="#000"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 14.25H11"
                  stroke="#000"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="text">Application Detail</span>
          </button>

          <button
            className={`action-btn ${activeTab === "track" ? "active" : ""}`}
            onClick={() => setActiveTab("track")}
          >
            <span className="icon">
              <svg
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 10.7501C8 11.811 8.42143 12.8285 9.17158 13.5787C9.92172 14.3288 10.9391 14.7503 12 14.7503C13.0609 14.7503 14.0783 14.3288 14.8284 13.5787C15.5786 12.8285 16 11.811 16 10.7501C16 9.68924 15.5786 8.67178 14.8284 7.92161C14.0783 7.17144 13.0609 6.75 12 6.75C10.9391 6.75 9.92172 7.17144 9.17158 7.92161C8.42143 8.67178 8 9.68924 8 10.7501Z"
                  stroke="#282828"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15.5 14.25L18 16.7501"
                  stroke="#282828"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 1.75H17"
                  stroke="#282828"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 7.75H5.00001"
                  stroke="#282828"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 13.75H5.00001"
                  stroke="#282828"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="text">Track Order</span>
          </button>
        </div>
                 <div>
           {activeTab === "application" ? (
             <Accordion activeKey={activeKey} className="orderdetail-accordion">
               {(orders?.orders?.[0]?.orderList || []).map((applicant: ApplicantType, idx: number) => (
                                 <Accordion.Item
                   eventKey={`item-${idx}`}
                   key={idx}
                   className={`orderdetail-box 
                     ${applicant.disabled ? "disabled" : ""} 
                     ${applicant.select ? "selected" : ""} 
                     ${applicant.statusClass || (applicant.serviceStatus?.includes('UNDER REVIEW') ? 'review' : 'verified')}`}
                 >
                  <Accordion.Header
                    onClick={() => handleAccordionToggle(`item-${idx}`)}
                  >
                    <div className="order-row-wrapper d-flex justify-content-between align-items-center w-100">
                      <div className="d-flex align-items-center w-100 gap-2">
                          <div className="order-col order-col-num rounded-3">
                           {idx + 1}
                         </div>
                         {applicant.applicationNumber && (
                         <div className="order-col order-col-id">
                           <div className="label">Application ID</div>
                           <div className="value text-main text-truncate">
                             GH-{applicant.applicationNumber}
                           </div>
                         </div>)}
                         <div className="order-col order-col-service">
                           <div className="label">Service</div>
                           <div className="value text-truncate">
                             {applicant.serviceName }
                           </div>
                         </div>
                         {!applicant.applicationNumber && (
                         <div className="order-col order-col-id">
                           <div className="label">No of Services</div>
                           <div className="value text-main text-truncate">
                             {applicant.details.length}
                           </div>
                         </div>)}
                         <div className="order-col order-col-name">
                           <div className="label">Applicant</div>
                           <div className="value text-truncate">
                             {applicant.applicant_Name }
                           </div>
                         </div>
                         <div className="order-col order-col-name">
                           <div className="label">Payment Status</div>
                           <div className="value text-truncate">
                             {applicant.paymentStatus || "Complete"}
                           </div>
                         </div>
                         <div
                           className={`order-col order-col-status ${applicant.statusClass || (applicant.serviceStatus?.includes('UNDER REVIEW') ? 'review' : 'verified')}`}
                         >
                           <div className="label text-end">Document Status</div>
                           <div className="value text-end">
                             {applicant.serviceStatus }
                           </div>
                         </div>
                        <div className="ms-3">
                          <img
                            src="https://goodhand.b-cdn.net/Assets/Upload/up-delete.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    {applicant.documents ? (
                      <div className="doc-list-container">
                        {applicant.documents?.map((doc: DocumentType, _i: number) => (
                          <div
                            className={`doc-row ${doc.statusClass}`}
                            key={_i}
                          >
                            <div className="doc-col doc-col-name">
                              <div className="doc-status-icon">
                                <i
                                  className={`fa-solid ${getIconClass(
                                    doc.statusClass
                                  )}`}
                                ></i>
                              </div>
                              <div className="doc-name">{doc.name}</div>
                            </div>
                            <div className="doc-col doc-col-status">
                              <div className="doc-status-text">
                                {doc.status}
                              </div>
                            </div>
                            <div className="doc-col doc-col-action">
                              {doc.action && (
                                <button className="btn btn-outline-secondary bg-white btn-sm upload-btn">
                                  {doc.action}
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <></>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          ) : (
            <Accordion className="orderdetail-accordion">
                {(orders?.orders?.[0]?.orderList || [])
                .filter((item: ApplicantType) => item.PackageId !== null && item.PackageId !== 0)
                .map((item: ApplicantType, idx: number) => (
                <Accordion.Item
                  eventKey={`track-${idx}`}
                  key={idx}
                  className="orderdetail-box"
                >
                  <Accordion.Header
                    onClick={() => handleAccordionToggle(`track-${idx}`)}
                  >
                    <div className="order-row-wrapper d-flex justify-content-between align-items-center w-100">
                      <div className="d-flex align-items-center w-100 gap-2">
                        <div className="order-col order-col-num rounded-3">
                          1
                        </div>
                        <div className="order-col order-col-id">
                          <div className="label">Track Order</div>
                          <div className="value text-main text-truncate">Timeline for {item.packageName} OR {item.applicant_Name}</div>
                        </div>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="container my-4">
                      <div className="position-relative ms-4">
                   
                        <div className="timeline-line position-absolute "></div>

                        {item.details.map((step: StepType, idx: number) => (
                          <div
                            key={idx}
                            className="row align-items-start mb-4 ps-4"
                          >
                            <div className="col-auto position-relative">
                              <div
                                className={`step-circle ${step.statusClass}`}
                              >
                                {idx +1}
                              </div>
                            </div>

                       
                            <div className="col border-bottom pt-1 pb-3">
                              <div className="row">
                                <div className="col-md-3">
                                  <div className="text-muted font-12">
                                    Application ID
                                  </div>
                                  <div className="text-main font-14 ff-semibold mb-0">
                                    {step.applicationNumber !== "-" ? (
                                      <a
                                     
                                        className="text-decoration-none"
                                      >
                                     GH-{step.applicationNumber}
                                      </a>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-5">
                                  <div className="text-muted font-12">
                                    Service
                                  </div>
                                  <div className="text-black font-14 ff-semibold mb-0">
                                    {step.serviceName}
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="text-muted font-12">
                                    Status
                                  </div>
                                  <div
                                    className={`text-black font-14 ff-semibold mb-0 ${
                                      step.statusClass === "done"
                                        ? "text-success"
                                        : step.statusClass === "inprocess"
                                        ? "text-warning"
                                        : "text-danger"
                                    }`}
                                  >
                                    {step.serviceStatus}
                                  </div>
                                </div>
                                <div className="col-md-1 ">
                                  <div className="px-2 py-3 layout-border bg-white d-flex align-items-center rounded-3 justify-content-center">
                                    <svg
                                      width="20"
                                      height="14"
                                      viewBox="0 0 20 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8 7C8 7.53043 8.21071 8.03914 8.58579 8.41421C8.96086 8.78929 9.46957 9 10 9C10.5304 9 11.0391 8.78929 11.4142 8.41421C11.7893 8.03914 12 7.53043 12 7C12 6.46957 11.7893 5.96086 11.4142 5.58579C11.0391 5.21071 10.5304 5 10 5C9.46957 5 8.96086 5.21071 8.58579 5.58579C8.21071 5.96086 8 6.46957 8 7Z"
                                        stroke="black"
                                        strokeWidth="1.25"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M19 7C16.6 11 13.6 13 10 13C6.4 13 3.4 11 1 7C3.4 3 6.4 1 10 1C13.6 1 16.6 3 19 7Z"
                                        stroke="black"
                                        strokeWidth="1.25"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          )}
        </div>
      </div>
    </>
  );
};

export default OrderDetails;

